<template>
  <div>
    <v-timeline-item color="blue-pcm" small v-if="typeof evento === 'string'">
      <v-card color="background"> <strong>Evento: </strong> ligação transferida </v-card>
    </v-timeline-item>
    <v-timeline-item color="bluePcm" small v-else>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Evento: Transferência para Conferência
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col>
            <v-card-text>
              <strong>Data início: </strong>
              {{ convertDateFormat(evento.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Centro de Custo: </strong>
              {{
                evento.centroDeCusto
                  ? `${evento.centroDeCusto.codigo} - ${evento.centroDeCusto.description}`
                  : 'Sem Centro de Custo'
              }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row dense align="center">
          <v-col>
            <v-card-text>
              <strong>Conferência: </strong>
              {{ getDescriptionConferencia(evento.atdCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Participante: </strong>
              {{ evento.transferido }}
            </v-card-text>
          </v-col>

          <v-col>
            <v-card-text>
              <strong>Transferido por: </strong>
              {{ evento.numeroOrigem }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-timeline-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import relatorioChamadasStore from '../_store'

import { sharedMethods } from '../_utils/sharedMethods'

export default {
  name: 'TimeLineTransferencia',
  props: {
    evento: Object || String,
  },
  computed: {
    ...mapGetters('listaRelatorioChamadasModulePABXStore', ['getSpecificConferencia']),
  },
  async created() {
    registerVuexModule(this.$store, 'listaRelatorioChamadasModulePABXStore', relatorioChamadasStore)
  },
  methods: {
    ...sharedMethods,

    getDescriptionConferencia (dado){
      let conferencia = this.getSpecificConferencia(dado)
      if(conferencia){
        return conferencia.description
      }else{
        return ''
      }
    }
  },
}
</script>
